export const MONEY_DAO_LINKS = {
  VOTING_POWER: "https://www.tally.xyz/gov/money/my-voting-power",
  DELEGATES: "https://www.tally.xyz/gov/money/delegates",
};

export const getMoneyDAODelegateLink = (address: string) => `https://www.tally.xyz/gov/money/delegate/${address}`;
